import React from "react";
import UserState from "state/UserState";
import Cms from "./Cms";

export default () => {
  const { selectedOrgId } = UserState.useContainer();

  return <Cms key={selectedOrgId} orgId={selectedOrgId} />;
};
